import { BaseValidationRuleResolver } from './BaseValidationRuleResolver';

export const materialPropertiesListValidationRuleResolver: BaseValidationRuleResolver<{ unit: string; value: number }[]> = (
  value,
  rule,
  property,
  path,
  context
) => {
  const referenceFlowUnit = context.getRefValue(property, path, rule.referenceFlowUnitRefId) as string | null;
  if (!referenceFlowUnit) {
    return null;
  }

  const containsUnit = (unit: string) => value.some((v) => v.unit === unit);

  switch (referenceFlowUnit) {
    case 'mass_kg':
      return containsUnit('volumetric_mass_density')
        ? null
        : 'For a reference flow with the unit Mass (kg), the following is mandatory: Volumetric mass density (kg/m³).';
    case 'length_m':
      return containsUnit('linear_mass_density')
        ? null
        : 'For a reference flow with the unit Length (m), the following is mandatory: Linear mass density (kg/m).';
    case 'area_m2':
      return containsUnit('area_density') && containsUnit('thickness')
        ? null
        : 'For a reference flow with the unit Area (m²), the following is mandatory: Area density (kg/m²), Thickness (m).';
    case 'volume_m3':
      return containsUnit('volumetric_mass_density')
        ? null
        : 'For a reference flow with the unit Volume (m³), the following is mandatory: Volumetric mass density (kg/m³).';
    case 'number_of_pieces':
      return containsUnit('mass_per_piece')
        ? null
        : 'For a reference flow with the unit Number of pieces (piece), the following is mandatory: Mass per piece (kg/piece).';
    default:
      return null;
  }
};
